import styled from '@mui/material/styles/styled';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { Button } from '@/components/ui/buttons/Button/Button';

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 1.94rem;

  ${({ theme }) => theme.breakpoints.down('md')} {
    gap: 1.25rem;
  }
`;

export const Title = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Options = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const MuiOtpInputStyled = styled(MuiOtpInput, { shouldForwardProp: (prop: string) => prop !== 'error' })<{
  error?: boolean;
}>(({ error, theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '0.25rem',

  input: {
    boxSizing: 'border-box',
    width: '2.5rem',
    height: '2.5rem',
    padding: '0.94rem',
    borderRadius: '8px',
    textAlign: 'center',
    color: error ? theme.palette.text.red : theme.palette.text.primary,
    background: theme.palette.inputField.fillLight,
    border: '1px solid',
    borderColor: error ? theme.palette.border.red : 'transparent',

    '&:hover': {
      borderColor: error ? theme.palette.border.red : theme.palette.inputField.hover,
    },

    '&:focus': {
      border: `2px solid ${error ? theme.palette.border.red : theme.palette.inputField.focused}`,
    },

    '&:focus-visible': {
      outline: 0,
    },
  },

  fieldset: {
    borderColor: 'transparent',
    border: 'none',
  },

  '@media screen and (min-width: 720px)': {
    input: {
      width: '3.5rem',
      height: '3.5rem',
    },
  },
}));

export const AdaptiveButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    height: 2.5rem;
  }
`;
